import { createFocusTrap } from "../functions/focusTrap.js";

export const init = () => {
    const searchContainer = document.getElementById("search");
    if (!searchContainer) return;

    const focusTrap = createFocusTrap(searchContainer);
    let triggerButton = null;

    const openSearch = () => {
        document.body.classList.add("search-open");
        focusTrap.enable();
        if(triggerButton) triggerButton.setAttribute("aria-expanded", "true");
        setTimeout(() => {
            document.addEventListener("click", clickOutsideListener);
        }, 0);
    };

    const closeSearch = () => {
        document.body.classList.remove("search-open");
        focusTrap.disable();
        document.removeEventListener("click", clickOutsideListener);
        if (triggerButton) {
            triggerButton.setAttribute("aria-expanded", "false");
            triggerButton.focus();
            triggerButton = null;
        }
    };

    const clickOutsideListener = (e) => {
        if (!searchContainer.contains(e.target) && !e.target.closest(".btn-search")) {
            closeSearch();
        }
    };

    document.querySelectorAll(".btn-search").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            triggerButton = btn;
            if(document.body.classList.contains("search-open")) {
                closeSearch();
            } else {
                openSearch();
            }
        });
    });

    document.querySelectorAll(".search-close").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            closeSearch();
        });
    });

    // Close on Escape key
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && document.body.classList.contains("search-open")) {
            closeSearch();
        }
    });

    const closeOnWide = () => {
        if (window.innerWidth >= 992) {
            document.body.classList.remove("search-open");
            focusTrap.disable();
        }
    };

    window.addEventListener("load", closeOnWide);
    window.addEventListener("resize", closeOnWide);
};
